/*
 * HomeReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */
import {
  DEFAULT_ENTITY,
  LOADER_STATUS,
  PROFILE_DATA,
  SET_ENTITY_LIST,
  STORE_GSTIN_GSTR2A2BNEW,
  STORE_PERIOD,
  STORE_PERIOD_SINGLE,
  IS_CHECKED_2A2B,
  ENTITY_LABEL
} from "./constants";

// The initial state of the App
export const initialState = {
  loaderStatus: false,
  defaultEntity: "",
  profileData: [],
  selectedGstin: [],
  entityMasterList: [],
  startDate: null,
  endDate: null,
  selectedPeriodSingle: null,
  isChecked:false,
  entityLabel:""
};

/* eslint-disable default-case, no-param-reassign */
const gstr2a2bNewCommonReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus,
      };
    case DEFAULT_ENTITY:
      return {
        ...state,
        defaultEntity: action.data,
      };
    case PROFILE_DATA:
      return {
        ...state,
        profileData: action.profileData,
      };
    case STORE_GSTIN_GSTR2A2BNEW:
      return {
        ...state,
        selectedGstin: action.selectedGstin,
      };
    case STORE_PERIOD:
      return {
        ...state,
        startDate: action.date.startDate,
        endDate: action.date.endDate,
      };
    case STORE_PERIOD_SINGLE:
      return {
        ...state,
        selectedPeriodSingle: action.date,
      };
      case SET_ENTITY_LIST:
        return {
          ...state,
          entityMasterList: action.payload,
        };
        case IS_CHECKED_2A2B:
        return {
          ...state,
          // isChecked: !state.isChecked,
          isChecked: action.payload,
        };
    case ENTITY_LABEL:
      return {
        ...state,
        entityLabel: action.payload,
      };
    default:
      return state;
  }
};

export default gstr2a2bNewCommonReducer;
